import { render, staticRenderFns } from "./NotificationListView.vue?vue&type=template&id=074c2131"
import script from "./NotificationListView.vue?vue&type=script&lang=js"
export * from "./NotificationListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports